module.exports = __webpack_public_path__ + "static/media/caz2.1c62ecae.jpg";